import React, { useState, useEffect, useMemo } from "react";
import { FaBars } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";
import {
  MenuIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLink,
  NavLogo,
  NavMenu,
  TranslateBtn,
} from "./NavbarElements";
import logo from "../../images/logo.png";
import logo2 from "../../images/logo2.png";
import Translate from "./translate/Translate";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const [scrollNav, setScrollNav] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollNav(currentScrollY <= lastScrollY);
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const iconContextValue = useMemo(() => ({ color: "#fff" }), []);

  return (
    <IconContext.Provider value={iconContextValue}>
      <Nav
        style={{
          transform: scrollNav ? "translateY(0)" : "translateY(-100%)",
          transition: "transform 0.3s ease-in-out",
          background: "#000", // Ensuring black background
        }}
      >
        <NavbarContainer>
          <NavLogo to="/" onClick={toggleHome}>
            <img src={logo2} alt="" style={{ width: 40 }} />
            <img src={logo} alt="" style={{ width: 145, maxWidth: "100%" }} />
          </NavLogo>
          <MenuIcon onClick={toggleMenu}>
            <FaBars />
          </MenuIcon>
          <NavMenu
            isOpen={isOpen}
            style={{
              flexDirection: i18n.language === "ar" ? "row-reverse" : "row",
            }}
          >
            <NavItem>
              <NavLink
                to="about"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                onClick={closeMenu}
              >
                {t("navbar.about")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="signup"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                onClick={closeMenu}
              >
                {t("navbar.SignUp")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="discover"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                onClick={closeMenu}
              >
                {t("navbar.Discover")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="services"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                onClick={closeMenu}
              >
                {t("navbar.Services")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="objectifs"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                onClick={closeMenu}
              >
                {t("navbar.objectifs")}
              </NavLink>
            </NavItem>
          </NavMenu>
          <TranslateBtn isOpen={isOpen}>
            <Translate />
          </TranslateBtn>
        </NavbarContainer>
      </Nav>
    </IconContext.Provider>
  );
};

export default Navbar;
